import React, { useRef } from "react";
import { sumArrayOfObjects } from "../../Utilitie";
import DownloadExcel from "../../Extra/DownloadExcel";
import NoDataFound from "../../Extra/NoDataFound";
import NewMultiLevelBarChart from "../../CHARTS/NewMultilevelBarChart";
import { buildAllLevelData } from "./PDDHelper";

// /////////////////////////////////////////////////////////////////////////////
const MonthWisePDD = ({ data, barColors, setSelectedMonth, selectedMonth }) => {
  const Years = [...new Set(data.map((d) => d.PDD_YEAR))].sort();
  const year1 = useRef();
  const year2 = useRef();
  const tableRef = [year1, year2];
  const tableHead = [
    "Month",
    "Cases ≤00:30 HRS",
    "Cases >00:30 AND ≤ 01:00 HRS",
    "Cases >01:00 AND ≤ 02:00 HRS",
    "Cases >02:00 AND ≤ 03:00 HRS",
    "Cases >03:00 HRS",
    "Total Cases",
  ];
  const CellBar = ({ value, max, color }) => {
    const width = max ? (value / max) * 100 : 0;
    return (
      <div className="position-relative" style={{ minWidth: "90px" }}>
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 4,
            height: "70%",
            width: `${width}%`,
            backgroundColor: color,
            borderRadius: "3px",
            opacity: 0.35,
          }}
        ></div>
        <span className="position-relative fw-bold">{value}</span>
      </div>
    );
  };

  return (
    <div>
      <div className="row  align-items-stretch newUiBody m-1 mt-2">
        <h5 className="bg-dark text-white p-1">Month Wise PDD</h5>
        <div className="row">
          {Years.map((y, k) => {
            let fData = data.filter((d) => d.PDD_YEAR === y);
            const allLevelData = buildAllLevelData(fData);

            let sum = sumArrayOfObjects(
              fData,
              ["PDD_MONTH", "PDD_YEAR"],
              [],
              "group_id"
            );

            const maxValues = {
              c1: Math.max(...sum.map((s) => s.LESS_THEN_EQUAL_TO_THIRTY_MIN)),
              c2: Math.max(
                ...sum.map((s) => s.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR)
              ),
              c3: Math.max(
                ...sum.map((s) => s.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR)
              ),
              c4: Math.max(
                ...sum.map((s) => s.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR)
              ),
              c5: Math.max(...sum.map((s) => s.MORE_THEN_THREE_HOURS)),
              total: Math.max(
                ...sum.map(
                  (s) =>
                    s.LESS_THEN_EQUAL_TO_THIRTY_MIN +
                    s.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR +
                    s.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR +
                    s.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR +
                    s.MORE_THEN_THREE_HOURS
                )
              ),
            };

            return (
              <div
                className={`col-md-${Years.length === 2 ? "6" : "12"}`}
                key={k}
              >
                <div className="table-responsive m-1 table-wrapper h-100  newUiBody">
                  <h5 className="bg-dark text-white">{y}</h5>
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        {/* <PDDMultiLevelChart
                          filteredData={fData}
                          year={y}
                          height={450}
                        /> */}
                        <NewMultiLevelBarChart
                          allLevelData={allLevelData}
                          rootId="months"
                        />
                      </div>
                    </div>
                  </div>
                  <table
                    className="table newUiTable table-striped table-hover "
                    ref={tableRef[Years.indexOf(y)]}
                  >
                    <thead className="table-dark">
                      <tr>
                        {tableHead.map((th, i) => (
                          <th className="text-wrap" key={i}>
                            {th}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {sum.map((s, j) => {
                        const total =
                          s.LESS_THEN_EQUAL_TO_THIRTY_MIN +
                          s.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR +
                          s.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR +
                          s.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR +
                          s.MORE_THEN_THREE_HOURS;

                        return (
                          <tr
                            style={{ cursor: "pointer" }}
                            className={
                              s.PDD_MONTH === selectedMonth[`${y}-month`] &&
                              "table-primary"
                            }
                            key={j}
                            onClick={() => {
                              setSelectedMonth({
                                ...selectedMonth,
                                [s.PDD_YEAR]: s.PDD_YEAR,
                                [`${s.PDD_YEAR}-month`]: s.PDD_MONTH,
                              });
                            }}
                          >
                            <td>{s.PDD_MONTH}</td>

                            <td>
                              <CellBar
                                value={s.LESS_THEN_EQUAL_TO_THIRTY_MIN}
                                max={maxValues.c1}
                                color={barColors.c1}
                              />
                            </td>
                            <td>
                              <CellBar
                                value={
                                  s.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR
                                }
                                max={maxValues.c2}
                                color={barColors.c2}
                              />
                            </td>
                            <td>
                              <CellBar
                                value={s.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR}
                                max={maxValues.c3}
                                color={barColors.c3}
                              />
                            </td>
                            <td>
                              <CellBar
                                value={
                                  s.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR
                                }
                                max={maxValues.c4}
                                color={barColors.c4}
                              />
                            </td>
                            <td>
                              <CellBar
                                value={s.MORE_THEN_THREE_HOURS}
                                max={maxValues.c5}
                                color={barColors.c5}
                              />
                            </td>
                            <td>
                              <CellBar
                                value={total}
                                max={maxValues.total}
                                color={barColors.total}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {fData?.length === 0 ? (
                    <NoDataFound />
                  ) : (
                    <DownloadExcel
                      tableRef={tableRef[Years.indexOf(y)]}
                      fileName={`Crew PDD Month Wise ${y}`}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MonthWisePDD;
